export default __webpack_public_path__ + "static/media/googleLogo.325567fe.svg";